import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'
import { ordenarArrayObj } from '../../../../util/FuncoesComuns'

const VisualizacaoUsuario = (props) => {
    let { id } = useParams();
    const [dados, setDados] = useState({})
    const [tipoPessoa, setTipoPessoa] = useState(null)

    useEffect(() => {
        if (id)
            visualizar(`/controleAcesso/usuario`, id, obj => {
                setTipoPessoa(obj?.tipo_pessoa ?? null)
                setDados(obj)
            })
    }, [id])

    const data = dados.nome ? {
        titulo: 'Visualização de Usuário',
        grupos: [
            {
                titulo: 'Dados Gerais',
                colunas: [
                    {
                        titulo: 'Nome',
                        descricao: dados.nome,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Login',
                        descricao: dados.login,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'E-mail',
                        descricao: dados.email,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Vigência de Acesso Inicial',
                        descricao: dados.vigencia_acesso_inicial,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Vigência de Acesso Final',
                        descricao: dados.vigencia_acesso_ativo,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Ativo?',
                        descricao: dados.ativo.label,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Tipo Usuário',
                        descricao: dados.usuario_tipo?.label ?? '',
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: `Prestador`,
                        descricao: dados?.prestador?.label ?? '',
                        tamanho: 'col-lg-6'
                    },
                    {   
                        titulo: 'Data de Registro',
                        descricao: dados.data_registro,
                        tamanho: 'col-lg-6'
                    }
                ]
            }, {
                tipoGrupo: 'tabela',
                titulo: 'Grupos',
                thead:
                    <tr>
                        <td className='coluna-6'>Código</td>
                        <td className='coluna-6'>Descrição</td>
                    </tr>,
                tbody: dados.grupos == undefined || dados.grupos.length < 1 ? (<><tr>
                    <td colspan="3">Sem Registro!</td>
                </tr></>) :
                    ordenarArrayObj(dados.grupos, 'id').map(item =>
                        <tr>
                            <td>{item.value}</td>
                            <td>{item.label}</td>
                        </tr>)
            }
        ]
    } : { titulo: 'Visualização de Usuário' }

    return (
        <VisualizacaoPadrao data={data} id={id} {...props} />
    )
}

export default VisualizacaoUsuario